import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "../hooks/auth";
import { AdminRoutes } from "./admin.routes";
import { AuthRoutes } from "./auth.routes";
import { JudgeRoutes } from "./judge.routes";
import { SharedRoutes } from "./shared.routes";

const AppRoutes: React.FC = () => {
  const { token, signOut, user } = useAuth();

  useEffect(() => {
    token && token.exp <= new Date().getTime() && signOut();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      {/* Public/Auth Routes */}
      {AuthRoutes({ user })}

      {/* Admin Routes (typeId === 1) */}
      {AdminRoutes({ user })}

      {/* Judge Routes (typeId === 2) */}
      {JudgeRoutes({ user })}

      {/* Shared/General Routes */}
      {SharedRoutes({ user })}

      {/* Fallback Route */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export { AppRoutes };
